import type { Root } from 'mdast';
import { visit } from 'unist-util-visit';

export const handleImageUrl =
  (
    searchHostnames: string[],
    replaceHostname: string,
    customDomainRequestPath?: string,
    isEnterpriseEdition?: boolean,
  ) =>
  (url: string) => {
    try {
      const URLObj = new URL(url);
      const imageSrcHostname = URLObj.hostname;
      if (
        (!isEnterpriseEdition &&
          searchHostnames.includes(imageSrcHostname)) ||
        (isEnterpriseEdition && URLObj.pathname.startsWith('/api/v1/projects'))
      ) {
        // eslint-disable-next-line no-param-reassign
        const replaceUrl = `${URLObj.pathname}${URLObj.search}`;
        // 为了 explorer 中使用自定义域名的替换
        if (customDomainRequestPath !== undefined) {
          return `${customDomainRequestPath}${replaceUrl}`;
        }

        return replaceUrl;
      }
      return url;
    } catch (e) {}
    return url;
  };

export default function remarkImageReplaceHost(
  searchHostnames: string[],
  replaceHostname: string,
  customDomainRequestPath?: string,
  isEnterpriseEdition?: boolean,
) {
  const handler = handleImageUrl(
    searchHostnames,
    replaceHostname,
    customDomainRequestPath,
    isEnterpriseEdition,
  );
  return (tree: Root) => {
    visit(tree, 'image', (node) => {
      try {
        // eslint-disable-next-line no-param-reassign
        node.url = handler(node.url);
      } catch (error) {
        //
      }
    });
  };
}
